import { Component } from '@angular/core';

@Component({
  selector: 'app-my-space-billing',
  templateUrl: './my-space-billing.component.html',
  styleUrls: ['./my-space-billing.component.css'],
  standalone: false,
})
export class MySpaceBillingComponent {
  constructor() {}
}
